import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';

import { AccountManagementService } from '../../services/account-management.service';
import { BriefingConfig } from '@Admin/AccountManagement/models/briefing-config.model';

@Component({
    selector: 'agpr-briefing-config-preferences',
    templateUrl: './briefing-config-preferences.component.html',
    styleUrls: ['./briefing-config-preferences.component.scss'],
    standalone: false
})
export class BriefingConfigPreferencesComponent implements OnInit, OnDestroy {
    readonly messageSeverityEnum = messageSeverityEnum;
    private readonly subscriptions: Subscription[] = [];

    briefingConfigs: BriefingConfig;

    alertLimit: number = 30;
    showWarningMessage: boolean = false;

    constructor(
        private accountManagementService: AccountManagementService,
    ) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.accountManagementService.getBriefingConfig().subscribe((config) => {
                this.briefingConfigs = config;
                if (!!this.briefingConfigs.alertLimit) {
                    this.alertLimit = this.briefingConfigs.alertLimit;
                } else {
                    this.alertLimit = -1;
                }
            })
        );
    }

    checkAlertLimit() {
        if (this.alertLimit === null || this.alertLimit === undefined) {
            this.alertLimit = this.briefingConfigs.alertLimit;
        } else {
            this.briefingConfigs.alertLimit = this.alertLimit;
        }

        // cannot set the limit lower than the active alert count
        if ((this.alertLimit !== -1) && (this.alertLimit < this.briefingConfigs?.activeAlertTotal)) {
            this.alertLimit = this.briefingConfigs?.activeAlertTotal;
            this.briefingConfigs.alertLimit = this.alertLimit;
            this.showWarningMessage = true;
        }
    }

    checkActiveAlertTotal() {
        this.showWarningMessage = false;
    }

    ngOnDestroy(): void {
        this.subscriptions?.forEach(subscription => subscription.unsubscribe());
    }
}
